import { FC, useEffect } from 'react';
import { useCallbackRef } from '@restart/hooks';
import Swiper from 'swiper';
import swiperCss from '@edikk-edikk/country-common/css/modules/swiper.module.scss';
import { GalleryItem } from '#advertDetail/components/gallery/item/GalleryItem';
import { useGalleryContext } from '#advertDetail/components/gallery';
import { useAdvertDetailContext } from '#advertDetail/hooks';

const GalleryItemList: FC = () => {
  const {
    advert: {
      photos,
    },
  } = useAdvertDetailContext();
  const [container, setContainer] = useCallbackRef<HTMLDivElement>();
  const { refSwiperOriginalList, setActivePhotoIndex } = useGalleryContext();

  useEffect(() => {
    if (!container) {
      return;
    }

    refSwiperOriginalList.current = new Swiper(container, {
      slidesPerView: 1,
      loop: photos.length > 1,
      wrapperClass: swiperCss.swiper__wrapper,
      slideClass: swiperCss.swiper__slide,
      on: {
        slideChange: (swiper: Swiper) => {
          setActivePhotoIndex(swiper.realIndex);
        },
      },
    });
  }, [container, photos.length, refSwiperOriginalList, setActivePhotoIndex]);

  const galleryItemList = photos.map((photo) => (
    <GalleryItem key={photo.id} photo={photo} />
  ));

  return (
    <div ref={setContainer}>
      <div className={swiperCss.swiper__wrapper}>
        {galleryItemList}
      </div>
    </div>
  );
};

export { GalleryItemList };
